module.exports = __webpack_public_path__ + "static/media/opencv.090c5960.svg";